export default "__VITE_ASSET__823e3d0d__"